import {useMount as _useMount} from 'react-use';

import utils from '@utils';
import constants from '@constants';

import {Props} from './types';

export const useMount = (
  props: Props,
  state: {setLoading: React.Dispatch<React.SetStateAction<boolean>>}
) => {
  _useMount(async () => {
    const currentDate = utils.date.getNow('YYYY年MM月DD日 HH時mm分ss秒');
    utils.scroll.top();
    const notification = await props.actions.notifications.getSummarizedNotification(
      {
        teamId: props.me.teamId,
        currentDate: utils.date.getNow('YYYY/MM/DD', true),
        traceDuration: constants.DATES.THIRD_DAY,
      }
    );
    props.actions.notifications.updateSearchTime(currentDate);

    if (notification.value.detail.data.notificationIds) {
      await props.actions.notifications.updateCurrentNotificationDetail({
        page: 1,
        sort: '-replyDatetime',
        teamId: props.me.teamId,
        notificationId: notification.value.detail.data.notificationIds,
      });
    } else {
      props.actions.notifications.clearDetailSort();
    }

    props.actions.users.clearTableSort();
    props.actions.users.clearUserDetail();
    props.actions.notifications.clearDetailSearch();

    state.setLoading(false);
  });
};
